module.exports = __webpack_public_path__ + "static/media/national-map-mobile.8387e1ae.svg";